// import { formatPhoneNumber } from 'components/utils/FormatData';
import React from 'react';

const PhoneRenderer = (props) => {

    // if (props.value) {
    //     return (
    //         <div>
    //             {formatPhoneNumber(props.value)}
    //         </div>
    //     );
    // } else {
    //     return props.value;
    // }
    return <div></div>

};

export default PhoneRenderer;